// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputs-container {
  display: flex;
  justify-content: space-between;
}

.input-container {
  flex: 1 1;
  margin: 10px 40px 10px 40px;
}

.input-range, .input-number {
  width: 100%;
  height: 25px;
  padding: 5px;
  border: 1px solid #23256c;
  border-radius: 10px;
  padding: 8px 16px;
  font-size: large;
  color: #23256c;
  box-sizing: border-box;
  text-align: center;
}

.input-range {
  background: #ddd;
  outline: none;
  opacity: 0.7;
  transition: opacity .2s;
}

.input-range:hover {
  opacity: 1;
}

.content-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    background-color: white;
    margin-top: 94.5px;
    padding: 20px;
    padding-top: 0;
    text-align: center;
  }

  img {
    max-width: 1140px;
  }

  .content-title {
    background-color: transparent;
    border: 1px solid #23256c;
    color: #23256c;
    border-radius: 10px;
    margin-top: 40px;
    padding: 8px 16px;
    font-weight: bold;
    font-size: large;
  }

  .content-subtitle {
    background-color: transparent;
    border: 1px solid #23256c;
    color: #23256c;
    border-radius: 10px;
    padding: 8px 16px;
    font-size: medium;
  }
  
  iframe {
    margin-top: 20px;
    max-width: 1140px;
  }

  .start-button {
    margin-top: 25px;
  }

  .start-button button {
    background-color: #23256c;
    border: 1px solid #23256c;
    color: #fff;
    border-radius: 10px;
    padding: 8px 16px;
    font-weight: bold;
    font-size: large;
    cursor: pointer;
  }
   
  .start-button button:hover {
    background-color: #fff;
    color: #23256c;
  }`, "",{"version":3,"sources":["webpack://./src/components/start/start.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,cAAc;EAChB","sourcesContent":[".inputs-container {\n  display: flex;\n  justify-content: space-between;\n}\n\n.input-container {\n  flex: 1;\n  margin: 10px 40px 10px 40px;\n}\n\n.input-range, .input-number {\n  width: 100%;\n  height: 25px;\n  padding: 5px;\n  border: 1px solid #23256c;\n  border-radius: 10px;\n  padding: 8px 16px;\n  font-size: large;\n  color: #23256c;\n  box-sizing: border-box;\n  text-align: center;\n}\n\n.input-range {\n  background: #ddd;\n  outline: none;\n  opacity: 0.7;\n  transition: opacity .2s;\n}\n\n.input-range:hover {\n  opacity: 1;\n}\n\n.content-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    background-color: white;\n    margin-top: 94.5px;\n    padding: 20px;\n    padding-top: 0;\n    text-align: center;\n  }\n\n  img {\n    max-width: 1140px;\n  }\n\n  .content-title {\n    background-color: transparent;\n    border: 1px solid #23256c;\n    color: #23256c;\n    border-radius: 10px;\n    margin-top: 40px;\n    padding: 8px 16px;\n    font-weight: bold;\n    font-size: large;\n  }\n\n  .content-subtitle {\n    background-color: transparent;\n    border: 1px solid #23256c;\n    color: #23256c;\n    border-radius: 10px;\n    padding: 8px 16px;\n    font-size: medium;\n  }\n  \n  iframe {\n    margin-top: 20px;\n    max-width: 1140px;\n  }\n\n  .start-button {\n    margin-top: 25px;\n  }\n\n  .start-button button {\n    background-color: #23256c;\n    border: 1px solid #23256c;\n    color: #fff;\n    border-radius: 10px;\n    padding: 8px 16px;\n    font-weight: bold;\n    font-size: large;\n    cursor: pointer;\n  }\n   \n  .start-button button:hover {\n    background-color: #fff;\n    color: #23256c;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
